import React, { useContext, useRef, useState } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration, getReservationCodeType, setReservationCodeType } from '../../data/utils';
import { getLabel } from '../../InitData';
import CustomAliasesToggle from './CustomAliasesToggle';
import { UserContext } from '../../data/betslip/UserConf';

function BetslipSettings(props) {
    const conf = getConfiguration();
    const betslipContext = useContext(BetslipContext);
    const ctxs = useRef({}).current;
    ctxs.betslipContext = useContext(BetslipContext);
    const couponKey = ctxs.betslipContext.betslipData?.selectedCoupon;
    let betslipData = betslipContext.getBetslipData();
    const [useQrCode, setUseQrCode] = useState(getReservationCodeType() === 'qrCode');
    const coupon = betslipData.coupons[couponKey];
    const varOddSelectedClass = 'bg-nero bianco';
    const varOddUnselectedClass = 'bg-grigio-chiaro nero';
    let varOdd = coupon.oddVariation;
    const userContext = useContext(UserContext);
    const user = userContext.getUser();
    const [isNotificationsWinningsEnabled, setIsNotificationsWinningsEnabled] = useState(userContext.isAutoNotificationWinningTicketEnabled());
    const [isNotificationsEventsEnabled, setIsNotificationsEventsEnabled] = useState(userContext.isAutoNotificationEventsScoreEnabled());

    function toggleReservationPrintType() {
        if (useQrCode) {
            setReservationCodeType('barcode');
        } else {
            setReservationCodeType('qrCode');
        }
        setUseQrCode(!useQrCode);
    }


    function changeVarOdd(oddVariation) {
        betslipContext.changeOddVariation(oddVariation, true);
    }

    function toggleNotificationsEvents(e) {
        const isChecked = e.target.checked;
        userContext.setAutoNotificationEventsScore(isChecked);
        setIsNotificationsEventsEnabled(isChecked);
    }

    function toggleNotificationsWinnings(e) {
        const isChecked = e.target.checked;
        userContext.setAutoNotificationWinningTicket(isChecked);
        setIsNotificationsWinningsEnabled(isChecked);
    }

    return (
        <div className="betslip-settings-container">
            <>
                <div>
                    <label className="custom-switch-2">
                        <input type="checkbox" checked={useQrCode} onChange={toggleReservationPrintType} />
                        <span className="custom-slider-2 round"></span>
                    </label>
                    <span className="ml-2">{getLabel('carrello.use_qr_code_for_reserved_ticked')}</span>
                </div>
                <div>
                    <label className="custom-switch-2">
                        <input id="fastBetBtn" type="checkbox" onChange={() => { betslipContext.toggleSaveBetslipAfterPurchase() }}
                            checked={betslipContext.isSaveBetslipAfterPurchaseEnabled()}></input>
                        <span className="custom-slider-2 round"></span>
                    </label>
                    <span className="ml-2">{getLabel('carrello.save_ticket')}</span>
                </div>
                {conf.pnc?.enabled && user && user.logged &&
                    <>
                        <div>
                            <label className="custom-switch-2">
                                <input id="notifications__winning"
                                    type="checkbox"
                                    checked={isNotificationsWinningsEnabled}
                                    onChange={toggleNotificationsWinnings}
                                ></input>
                                <span className="custom-slider-2 round"></span>
                            </label>
                            <span className="ml-2">{`Notifiche vincita (Android App)`}</span>
                        </div>
                        <div>
                            <label className="custom-switch-2">
                                <input id="notifications__events"
                                    type="checkbox"
                                    checked={isNotificationsEventsEnabled}
                                    onChange={toggleNotificationsEvents}
                                ></input>
                                <span className="custom-slider-2 round"></span>
                            </label>
                            <span className="ml-2">{`Notifiche info evento (Android App)`}</span>
                        </div>
                    </>
                }
                {conf.iwh &&
                    <div className="container-variazioni-quote var__quote-wrapper">
                        <div className="box-vincita-potenziale testo-var-quote">{getLabel('carrello.odds_variation')}</div>
                        <div className="box-vincita-potenziale testo-piccolo bottoni-var-quote">
                            <a onClick={() => changeVarOdd('NEVER')} className={"bottone px-2 var__quote-never " + (varOdd === 'NEVER' ? varOddSelectedClass : varOddUnselectedClass) + " margine-dx-mezzo"}>
                                {getLabel('carrello.accept_odds_variation.never')}
                            </a>
                            <a onClick={() => changeVarOdd('ALWAYS')} className={"bottone px-2 var__quote-always " + (varOdd === 'ALWAYS' ? varOddSelectedClass : varOddUnselectedClass) + " margine-dx-mezzo"}>
                                {getLabel('carrello.accept_odds_variation.always')}
                            </a>
                            <a onClick={() => changeVarOdd('INCR')} className={"bottone px-2 var__quote-incr " + (varOdd === 'INCR' ? varOddSelectedClass : varOddUnselectedClass)}>
                                {getLabel('carrello.accept_odds_variation.increasing')}
                            </a>
                        </div>
                    </div>
                }
                {conf.cal &&
                    <CustomAliasesToggle />
                }

            </>
        </div>
    );
}

export default BetslipSettings;